'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserNotificationPreference } from '../../Entities/User/UserNotificationPreference';
import { UserNotificationPreferenceCollection } from '../../Collections/User/UserNotificationPreferenceCollection';

export class UserNotificationPreferenceRepository extends CoreRepository {
  public getUserNotificationPreferences(userId: number, options: object = {}) {
    return this.webAPI.getUserNotificationPreferences(userId, options).then((response) => {
      const collection = new UserNotificationPreferenceCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserNotificationPreference();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public addUserNotificationPreference(userId: number, payload: any[]) {
    return this.webAPI.addUserNotificationPreference(userId, payload).then((response) => {
      const item = new UserNotificationPreference();
      item.hydrate(response);

      return item;
    });
  }

  public updateUserNotificationPreference(
    userId: number,
    notificationPreferenceId: number,
    payload: any[]
  ) {
    return this.webAPI
      .updateUserNotificationPreference(userId, notificationPreferenceId, payload)
      .then((response) => {
        return response;
      });
  }

  public deleteUserNotificationPreference(userId: number, notificationPreferenceId: number) {
    return this.webAPI
      .deleteUserNotificationPreference(userId, notificationPreferenceId)
      .then((response) => {
        return response;
      });
  }
}
